import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';

import Header from './Header';
import FaceMatchService from '../services/api/faceMatch';
import { processID } from './actions/processDataActions';
import Processing from './Processing';
import Encrypt from '../utilities/Encrypt';

class CaptureSelfie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      inputValue: '',
      selfie: null,
    };
  }

  componentDidMount() {
    let { instanceID } = this.props;
    this.props.processID(instanceID);
  }

  processSelfieAndRedirect() {
    if (this.props.resultData !== null) {
      if (this.props.resultData.Photo.split(',')[1] !== undefined) {
        if (this.state.selfie !== null) {
          FaceMatchService.processFaceMatch({
            Data: {
              ImageOne: this.props.resultData.Photo.split(',')[1],
              ImageTwo: this.state.selfie,
            },
            Settings: {
              SubscriptionId: Encrypt.auth.subscription_id,
            },
          })
            .then((res) => {
              const imgToUint8Array = (img) => {
                // Decode the dataURL
                const binary = atob(img);
                // Create 8-bit unsigned array
                const array = [];
                for (let i = 0; i < binary.length; i++) {
                  array.push(binary.charCodeAt(i));
                }
                // Return our Blob object
                return new Uint8Array(array);
              };
              this.setState({ loading: false });
              this.props.dispatch({
                payload: {
                  score: res.Score,
                  isMatch: res.IsMatch,
                  selfie: imgToUint8Array(this.state.selfie),
                },
                type: '@@acuant/ADD_FACE_MATCH_RESULT_DATA',
              });
              this.props.dispatch({ payload: res.Score, type: '@@acuant/ADD_FACE_MATCH_DATA' });
              this.props.history.push('/results/default');
            })
            .catch((err) => {
              throw new Error(err);
            });
        }
      } else {
        this.props.history.push('/results/default');
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.resultData !== this.props.resultData) {
      this.processSelfieAndRedirect();
    }
  }

  updateInputValue(evt) {
    let self = this;
    let file = evt.target;
    let reader = new FileReader();
    reader.readAsDataURL(file.files[0]);
    reader.onload = (e) => {
      self.setState({ loading: true });
      let img = document.createElement('img');
      img.src = e.target.result;
      img.onload = function () {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        let MAX_WIDTH = 480;
        let MAX_HEIGHT = 640;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        let dataurl = canvas.toDataURL(file.files[0].type, 90 * 0.01);
        let selfie = dataurl.split(',')[1];
        self.setState(
          {
            selfie,
          },
          () => {
            self.forceUpdate();
            self.processSelfieAndRedirect();
          },
        );
      };
    };
  }

  openFrontCamera() {
    window.AcuantPassiveLiveness.startSelfieCapture(this.onCaptured.bind(this));
  }

  onCaptured(image) {
    this.setState({ loading: true });
    window.AcuantPassiveLiveness.postLiveness(
      {
        endpoint: process.env.REACT_APP_LIVENESS_ENDPOINT,
        token: localStorage.getItem('AUTH_TOKEN'),
        image: image,
        subscriptionId: localStorage.getItem('SUBSCRIPTION_ID'),
      },
      function (result) {
        this.props.dispatch({ payload: result, type: '@@acuant/ADD_FACE_LIVENESS_DATA' });
        this.setState(
          {
            selfie: image,
          },
          () => {
            this.forceUpdate();
            this.processSelfieAndRedirect();
          },
        );
      }.bind(this),
    );
  }

  render() {
    const { t } = this.props;
    if (this.state.loading) {
      return <Processing />;
    }
    return (
      <Fragment>
        <Header />

        <div className="body column capture_photo">
          <div className="row wrapper description_container">
            <p className="description">
              {t('Take a selfie image using the front camera of your device.')}
            </p>
          </div>

          <div className="capture_group">
            <div className="row wrapper capture_container">
              <img
                alt="idscango"
                className="capture"
                src={require('../assets/images/illustration2@3x.png')}
              />
            </div>

            <div className="wrapper column capture_controls">
              <label className="btn ifg" onClick={this.openFrontCamera.bind(this)}>
                <p className={'buttonBgText'}>{t('Take selfie image')}</p>
              </label>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    instanceID: state.config.instanceID,
    faceMatch: state.processedData.faceMatch,
    resultData: state.processedData.result,
    liveness: state.processedData.liveness,
  };
}

function mapDispatchToProps(dispatch) {
  let actions = bindActionCreators({ processID }, dispatch);
  return { ...actions, dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CaptureSelfie));
